const axios = require('axios')
const moment = require('moment')
const headers = { 'Content-Type': 'application/json' }

export default class IndicatorsService {
  static async getByDate (date = moment().format('YYYY-MM-DD')) {
    const url = `${process.env.VUE_APP_UTILS_API_HOST}/api/indicators`
    try {
      const { data } = await axios.get(`${url}/${date}`, { headers })
      return Promise.resolve(data)
    } catch (error) {
      console.error(error)
      return Promise.reject(error)
    }
  }
}
